import React, { useState, useEffect } from 'react';
import './ScrollToTop.css';

const ScrollToTop = ({ hideButton = false }) => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  const toggleVisibility = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollTop > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    
    // Check initial scroll position after a delay
    setTimeout(() => {
      toggleVisibility();
    }, 100);
    
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  // Don't render if button should be hidden or not visible due to scroll
  if (hideButton || !isVisible) {
    return null;
  }

  return (
    <div className="scroll-to-top">
      <button
        onClick={scrollToTop}
        className="scroll-to-top-btn"
        aria-label="Scroll to top"
        style={{ 
          position: 'fixed',
          bottom: '30px',
          left: '30px',
          zIndex: 16000
        }}
      >
        <i className="fas fa-chevron-up"></i>
      </button>
    </div>
  );
};

export default ScrollToTop;